import { CanvasUnitedLeftMenu } from './left-menu/CanvasUnitedLeftMenu';
import { CanvasUnitedRightMenu } from './CanvasUnitedRightMenu';
import { DashboardHeaderContainer } from './DashboardHeaderContainer';

export const UnitedDashboardHeader = () => {
  return (
    <DashboardHeaderContainer>
      <CanvasUnitedLeftMenu />
      <CanvasUnitedRightMenu />
    </DashboardHeaderContainer>
  );
};
